"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseRcCalendar = _interopRequireDefault(require("nicbase-rc-calendar"));

var _Picker = _interopRequireDefault(require("nicbase-rc-calendar/lib/Picker"));

var _locales = _interopRequireDefault(require("../locales"));

var _selectionModeFooter = _interopRequireDefault(require("./selection-mode-footer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var format = {
  date: 'LL',
  month: 'MMMM YYYY',
  year: 'YYYY'
};

var DayMonthYearPicker = function DayMonthYearPicker(_ref) {
  var inputLabel = _ref.inputLabel,
      hideLabel = _ref.hideLabel,
      locale = _ref.locale,
      timezone = _ref.timezone,
      value = _ref.value,
      selectionMode = _ref.selectionMode,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled;

  var _useState = (0, _react.useState)(selectionMode),
      _useState2 = _slicedToArray(_useState, 2),
      visibleMode = _useState2[0],
      setVisibleMode = _useState2[1];

  var _useState3 = (0, _react.useState)(value && _momentTimezone["default"].tz((0, _momentTimezone["default"])(value).locale(locale), timezone)),
      _useState4 = _slicedToArray(_useState3, 2),
      visibleValue = _useState4[0],
      setVisibleValue = _useState4[1]; // handle prop changes


  var prevValue = (0, _hooks.usePrevious)(value);
  var prevSelectionMode = (0, _hooks.usePrevious)(selectionMode);
  (0, _hooks.useDidUpdate)(function () {
    if (prevValue !== value && (!visibleValue || visibleValue && !visibleValue.isSame(value))) {
      setVisibleValue(value && _momentTimezone["default"].tz((0, _momentTimezone["default"])(value).locale(locale), timezone));
    }

    if (prevSelectionMode !== selectionMode && visibleMode !== selectionMode) {
      setVisibleMode(selectionMode);
    }
  }, [locale, prevSelectionMode, prevValue, selectionMode, timezone, value, visibleMode, visibleValue]);

  var onOk = function onOk() {
    onSelect({
      from: _momentTimezone["default"].tz(visibleValue, timezone).clone().startOf(visibleMode).toDate(),
      until: _momentTimezone["default"].tz(visibleValue, timezone).clone().endOf(visibleMode).toDate(),
      selectionMode: visibleMode
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_Picker["default"], {
    value: visibleValue && _momentTimezone["default"].tz((0, _momentTimezone["default"])(visibleValue).locale(locale), timezone),
    disabled: disabled,
    calendar: /*#__PURE__*/_react["default"].createElement(_nicbaseRcCalendar["default"], {
      showDateInput: false,
      locale: _locales["default"][locale],
      defaultValue: visibleValue,
      format: format[visibleMode],
      onChange: setVisibleValue,
      showOk: true,
      onOk: onOk,
      showClear: false,
      mode: visibleMode,
      showToday: false,
      renderFooter: function renderFooter() {
        return /*#__PURE__*/_react["default"].createElement(_selectionModeFooter["default"], {
          activeMode: visibleMode,
          onSelectMode: setVisibleMode,
          modes: {
            date: 'datepicker.rangeTabs.day',
            month: 'datepicker.rangeTabs.month',
            year: 'datepicker.rangeTabs.year'
          }
        });
      }
    })
  }, function () {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
      disabled: disabled,
      label: inputLabel,
      hideLabel: hideLabel,
      readOnly: true,
      value: value && _momentTimezone["default"].tz((0, _momentTimezone["default"])(value).locale(locale), timezone).format(format[selectionMode]) || ''
    });
  });
};

DayMonthYearPicker.propTypes = {
  timezone: _propTypes["default"].string,
  onSelect: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  locale: _propTypes["default"].string,
  inputLabel: _propTypes["default"].string,
  hideLabel: _propTypes["default"].bool,
  selectionMode: _propTypes["default"].oneOf(['date', 'month', 'year']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].number])
};
DayMonthYearPicker.defaultProps = {
  value: Date.now(),
  selectionMode: 'month',
  inputLabel: null,
  hideLabel: false,
  timezone: 'Europe/London',
  locale: 'en-GB',
  disabled: false,
  onSelect: function onSelect() {}
};
var _default = DayMonthYearPicker;
exports["default"] = _default;